import { render, staticRenderFns } from "./FilterCriterionDeleteDialog.vue?vue&type=template&id=5c6551dd&"
import script from "./FilterCriterionDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./FilterCriterionDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports